export enum PbhRequestOrderTabEnum {
  InfoTab = 0,
  ServiceableTab = 1,
  UnserviceableTab = 2,
  AltenatePn = 3,
  WRFC = 4,
}
